import { gql, useMutation } from '@apollo/client'
import { useAlert, useNotification } from '@btime/react-messager'
import { useTranslation } from 'react-i18next'

import { useCloseModal } from '../../../../components/modals/ModalsContext'
import { useTableActions } from '../../../../components/tables/MultiSelectTableContext'
import { formsClient } from '../../../../utils/apollo/api'

const MUTATION = gql`
  mutation RemoveForms($ids: [Int]) {
    removeForms(ids: $ids)
  }
`

export const useRemoveForms = () => {
  const { t } = useTranslation('listForms')
  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['Forms', 'FormsCount'],
    client: formsClient
  })
  const notify = useNotification()
  const modal = useAlert()
  const closeModal = useCloseModal()
  const { clearSelection } = useTableActions()

  const handleRequest = ids => {
    if (!modal.confirm({ title: t('removeConfirm') })) return false

    return request({ variables: { ids } }).then(resp => {
      if (!resp.errors) {
        if (clearSelection) clearSelection()
        if (closeModal) closeModal()
      } else {
        notify.error({ title: t('removeError') })
      }
    })
  }

  return [handleRequest, state]
}
